var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c("div", { class: _vm.the_class }, [
        _c(
          "div",
          { staticClass: "personalisation-overlay", attrs: { tabindex: "0" } },
          [
            _c("div", { staticClass: "personalisation-overlay-top" }, [
              _c("div", { staticClass: "personalisation-overlay-top-title" }, [
                _c("span", { staticClass: "pre-title" }, [
                  _vm._v("Personalise your item"),
                ]),
                _vm._v(" "),
                _c(
                  "h4",
                  {
                    staticClass: "title",
                    attrs: { id: "personalisationTitle" },
                  },
                  [_vm._v(_vm._s(_vm.productTitle))]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "personalisation-overlay-top-close personalisation__container-logo-close",
                  attrs: { tabindex: "0", type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        id: "SVGDoc",
                        width: "7",
                        height: "7",
                        xmlns: "http://www.w3.org/2000/svg",
                        version: "1.1",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xmlns:avocode": "https://avocode.com/",
                        viewBox: "0 0 7 7",
                      },
                    },
                    [
                      _c("defs"),
                      _c("desc", [_vm._v("Generated with Avocode.")]),
                      _c("g", [
                        _c("g", [
                          _c("title", [_vm._v("close_mini [#1522]")]),
                          _c("path", {
                            attrs: {
                              d:
                                "M4.90002,3.5v0l2.09998,2.10001v0l-1.40002,1.39999v0l-2.09998,-2.10001v0l-2.09998,2.10001v0l-1.40002,-1.39999v0l2.09998,-2.10001v0l-2.09998,-2.10001v0l1.40002,-1.39999v0l2.09998,2.10001v0l2.09998,-2.10001v0l1.40002,1.39999v0z",
                              fill: "#f1e6b2",
                              "fill-opacity": "1",
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "personalisation-overlay-bottom" }, [
              _c("div", { staticClass: "personalisation-overlay-image" }, [
                _c("img", {
                  attrs: {
                    loading: "lazy",
                    height: "190",
                    width: "190",
                    src: _vm.backgroundImage,
                    alt: _vm.productTitle,
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "personalisation-overlay-details" },
                [
                  _vm.bottledByForPersonalisation
                    ? _c("BottledByFor", {
                        attrs: {
                          variantId: _vm.variantId,
                          productId: _vm.productId,
                          setActive: _vm.setActive,
                          setAdding: _vm.setAdding,
                          "b2b-cart": _vm.b2bCart,
                        },
                      })
                    : _vm.bottledByOnlyPersonalisation
                    ? _c("BottledByOnly", {
                        attrs: {
                          variantId: _vm.variantId,
                          productId: _vm.productId,
                          setActive: _vm.setActive,
                          setAdding: _vm.setAdding,
                          "b2b-cart": _vm.b2bCart,
                        },
                      })
                    : _c(
                        "form",
                        {
                          staticClass: "product-aside-personalise-form",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _vm.isB2B
                            ? _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "Recipient name: " +
                                      _vm._s(_vm.b2bCart.recipientName)
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isB2B && _vm.b2bMultiPersonalisation
                            ? _c("div", [
                                _vm.feature.B2B.autofill_personalisation
                                  ? _c("div", { staticClass: "form-input" }, [
                                      _c(
                                        "div",
                                        {
                                          class: _vm.dropdownCss(),
                                          on: { click: _vm.toggleB2BDropdown },
                                        },
                                        [
                                          _c(
                                            "ul",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "product-variant-dropdown",
                                              },
                                            },
                                            [
                                              _c(
                                                "li",
                                                { staticClass: "selected" },
                                                [_vm._v("Select option")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "variant-dropdown",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setB2BDropdown(
                                                        "name"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.b2bCart
                                                          .recipientName
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.b2bCompany.companyName
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "variant-dropdown",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.setB2BDropdown(
                                                            "company"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.b2bCompany
                                                              .companyName
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "variant-dropdown",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setB2BDropdown(
                                                        "custom"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Custom message\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.feature.B2B.autofill_personalisation &
                                (_vm.b2bDropdown.selected !== "")
                                  ? _c("div", { staticClass: "form-input" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.message,
                                            expression: "message",
                                          },
                                        ],
                                        ref: "input",
                                        staticClass: "sensitive",
                                        attrs: {
                                          autofocus: "",
                                          disabled: _vm.adding,
                                          id: "personalisation-input",
                                          placeholder: "personalised message",
                                          maxlength: _vm.max_message_length,
                                          type: "text",
                                        },
                                        domProps: { value: _vm.message },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.message = $event.target.value
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          class:
                                            _vm.charCount >
                                            _vm.max_message_length
                                              ? "count-over"
                                              : "count",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.charCount) +
                                              "/" +
                                              _vm._s(_vm.max_message_length)
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _c("div", { staticClass: "form-input" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.message,
                                            expression: "message",
                                          },
                                        ],
                                        ref: "input",
                                        staticClass: "sensitive",
                                        attrs: {
                                          autofocus: "",
                                          disabled: _vm.adding,
                                          id: "personalisation-input",
                                          placeholder: "personalised message",
                                          maxlength: _vm.max_message_length,
                                          type: "text",
                                        },
                                        domProps: { value: _vm.message },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.message = $event.target.value
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          class:
                                            _vm.charCount >
                                            _vm.max_message_length
                                              ? "count-over"
                                              : "count",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.charCount) +
                                              "/" +
                                              _vm._s(_vm.max_message_length)
                                          ),
                                        ]
                                      ),
                                    ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isB2B && _vm.b2bMultiPersonalisation
                            ? _c("div", { staticClass: "form-input" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.message,
                                      expression: "message",
                                    },
                                  ],
                                  ref: "input",
                                  staticClass: "sensitive",
                                  attrs: {
                                    autofocus: "",
                                    disabled: _vm.adding,
                                    id: "personalisation-input",
                                    placeholder: "personalised message",
                                    maxlength: _vm.max_message_length,
                                    type: "text",
                                  },
                                  domProps: { value: _vm.message },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.message = $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    class:
                                      _vm.charCount > _vm.max_message_length
                                        ? "count-over"
                                        : "count",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.charCount) +
                                        "/" +
                                        _vm._s(_vm.max_message_length)
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              class: _vm.buttonAddClass,
                              staticStyle: { width: "100%" },
                              on: { click: _vm.addToCart },
                            },
                            [_vm._v("Add to cart")]
                          ),
                        ]
                      ),
                ],
                1
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }